module.exports = __webpack_public_path__ + "img/blog-single.b0bb06b9.jpg";